import Delayed from './Delayed'

export default Delayed
